/** @format */

import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const StageFlag = () =>
  (process.env.REACT_APP_STAGE_LABEL && (
    <div className="corner-ribbon top-left">
      {process.env.REACT_APP_STAGE_LABEL}
    </div>
  )) ||
  null;

const Header = (props) => (
  <React.Fragment>
    <div className="bk-zone bk-top">
      <div className="bk-region">
        <div className="bk-header">
          <StageFlag />
          <Link
            to={`${process.env.PUBLIC_URL}/`}
            className="bk-logo bk-retina"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/logo@2x.png)`,
            }}
          />
          <div id="menuToggle">
            <input type="checkbox" />

            <span></span>
            <span></span>
            <span></span>

            <ul id="menu">
              {/* Normal a instead of Link because Link doesn't trigger closing the menu. We could add back a menu closing callback if that isn't enough. */}
              <a href={`${process.env.PUBLIC_URL}/`}>
                <li>Medical Office</li>
              </a>
              {/* hide Flex for a while <a
                    href="https://welltower.com/wellflex"
                    target="blank"
                    rel="noopener noreferrer"
                  >
                    <li>wellFLEX</li>
                  </a>*/}
              <a href={`${process.env.PUBLIC_URL}/current-tenants`}>
                <li>Current Tenants</li>
              </a>
              {/*process.env.REACT_APP_STAGE_LABEL && (
                    <a href={`${process.env.PUBLIC_URL}/new-tenant`}>
                      <li style={{ display: "flex" }}>New Tenant Form</li>
                    </a>
                  )*/}
              <a
                href="https://welltower.com/about-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <li>About Welltower</li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default Header;
